import content from "../content/yhteystiedot";
import Meta from "../components/Meta";
import StructuredData from "../components/StructuredData";
import Address from "../components/Address";
import Hours from "../components/Hours";
import RichText from "../components/RichText";
import PreviewBanner from "../components/PreviewBanner";
import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";
import { formatPhoneNumber } from "../components/phoneUtils.js";

function stripScripts(html) {
  return html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "");
}

export default function Yhteystiedot({ companyInfo, pageContent, preview }) {
  //const cleanedNumber = formatPhoneNumber(companyInfo.phone);
  const cleanedEmbed = stripScripts(pageContent.googleMapEmbed);
  return (
    <>
      <Meta pageContent={pageContent} />
      <StructuredData />
      <div id="content">
        {preview && <PreviewBanner />}
        {pageContent.hero && (
          <section>
            <HeroSection content={pageContent.hero} />
          </section>
        )}
        <section className="page-section page-content page-width">
          {!pageContent.hero && (
            <h1 className="page-heading">{pageContent.title}</h1>
          )}
          <div
            className="mb-4 md:text-lg text-block"
            dangerouslySetInnerHTML={{ __html: content.content }}
          />
          <div className="md:flex w-full gap-y-4 gap-x-8">
            <div className="md:flex-1 mb-8 md:pt-4">
              <Address companyInfo={companyInfo} />
              {pageContent.googleMapEmbed && (
                <div
                  id="map"
                  className="map-wrapper mt-5"
                  dangerouslySetInnerHTML={{
                    __html: cleanedEmbed,
                  }}
                />
              )}
            </div>
            <div className="">
              <div>
                <div className="bg-gray-50 p-4 w-auto">
                  <h2 className="font-bold text-lg">{content.hoursTitle}</h2>
                  <div className="mb-4">
                    <Hours openingHours={companyInfo.openingHours} />
                  </div>
                  <div className="max-w-80">
                    <RichText value={pageContent.contactInstagram} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const [companyInfo, pageContent] = await Promise.all([
    getCompanyInfo(preview),
    getPageContent("yhteystiedot", preview),
  ]);
  //console.log("📄 fetched pageContent:", pageContent);
  return {
    props: {
      companyInfo,
      pageContent,
      preview,
    },
    //revalidate: siteConfig.revalidate,
  };
}
